<sbnb-apps-detail-page
  vendorCode="stayfi"
  name="StayFi"
  logoTile="/assets/images/apps/stayfi.svg"
  builtBy="StayFi"
  builtByLink="https://www.stayfi.com"
  [categories]="['Marketing']"
  [permissions]="[AppPermission.propertyListingRead, AppPermission.reservationRead, AppPermission.calendarRead]"
  email="support@stayfi.com"
  [helpArticles]="[
    {
      id: '8571696',
      title: 'How to integrate Hospitable with StayFi'
    }
  ]">
  <ng-container description>
    <p>
      StayFi is a powerful WiFi marketing and guest engagement platform designed for short-term rental owners and
      managers. It helps you collect valuable guest data and seamlessly re-engage visitors to boost direct bookings and
      upsell revenue while reducing OTA dependency.
    </p>

    <p class="mt-1">
      By installing StayFi's branded WiFi, every guest signs in using their email address, ensuring you collect contact
      information for your entire group—not just the booking lead. From there, you can use StayFi's automated email or
      SMS marketing tools to promote your properties, send special offers, and drive repeat stays.
    </p>

    <h3 class="text-lg font-medium mt-6 mb-2">Why Use StayFi?</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li>
        <strong>Capture Guest Data Effortlessly:</strong>
        Collect emails from every guest in a reservation through branded WiFi login pages.
      </li>
      <li>
        <strong>Increase Direct Bookings:</strong>
        Use automated email campaigns to re-engage past guests, share special promotions, and reduce OTA fees.
      </li>
      <li>
        <strong>Build a Stronger Brand:</strong>
        Create branded WiFi splash pages that enhance the guest experience and showcase your brand.
      </li>
      <li>
        <strong>Save Time with Automation:</strong>
        Seamlessly sync your property data through Hospitable to set up ready-to-send email marketing campaigns in
        minutes.
      </li>

      <li>
        <strong>Boost Revenue with Upsells:</strong>
        Promote early check-ins, late check-outs, and local experiences to drive incremental revenue during every stay.
      </li>
    </ul>

    <h3 class="text-lg font-medium mt-6 mb-2">How It Works:</h3>
    <ol class="pl-6 space-y-2">
      <li class="mb-0">
        <strong>Create Your StayFi Account</strong>
        <p class="m-0">
          Set up your free account at stayfi.com and opt into either WiFi Marketing or Email Marketing to get started
        </p>
      </li>
      <li class="mb-0">
        <strong>Sync with Hospitable</strong>
        <p class="m-0">
          Automatically import reservation details and property data from Hospitable to power targeted email marketing
          campaigns.
        </p>
      </li>
      <li class="mb-0">
        <strong>Automate Your Marketing</strong>
        <p class="m-0">
          Use StayFi's ready-to-send email templates for campaigns like post-departure promotions, stay anniversary
          emails, and last-minute availability alerts.
        </p>
      </li>
    </ol>

    <h3 class="text-lg font-medium mt-6">Grow Direct Bookings</h3>
    <p class="m-0">
      Re-engage past guests with personalized emails, exclusive discounts, and updates on your properties to encourage
      direct rebooking.
    </p>

    <h3 class="text-lg font-medium mt-6 mb-2">Key Features</h3>
    <ul class="list-disc pl-6 space-y-2 mb-5">
      <li>
        <strong>Guest Email Collection:</strong>
        Capture all guest emails through branded WiFi logins.
      </li>
      <li>
        <strong>Automated Email Campaigns:</strong>
        Set up one-click email automations like post-departure journeys, stay anniversaries, and last-minute deals in
        seconds.
      </li>
      <li>
        <strong>Native Upsell Integrations:</strong>
        Earn up to $20K a year per listing with integrated upselling storefronts designed to provide special experiences
        for guests.
      </li>
      <li>
        <strong>Automated SMS Tool:</strong>
        Automatically send marketing messages with 98%+ open rates that drive bookings, reviews, and incremental
        revenue.
      </li>
      <li>
        <strong>Seamless PMS Sync:</strong>
        Automatically sync property availability and guest data through Hospitable for easy campaign creation.
      </li>
      <li>
        <strong>Custom Branded Splash Pages:</strong>
        Deliver a branded WiFi sign-in experience that showcases your rental business.
      </li>
    </ul>

    <sbnb-image-carousel
      class="mt-5"
      [images]="[
        '/assets/images/apps/stayfi/1.png',
        '/assets/images/apps/stayfi/2.png',
        '/assets/images/apps/stayfi/3.png',
        '/assets/images/apps/stayfi/4.png'
      ]"></sbnb-image-carousel>

    <div class="mt-5" style="position: relative; padding-bottom: 56.25%; height: 0">
      <iframe
        src="https://www.youtube.com/embed/aktlPEE85LQ"
        frameborder="0"
        allowfullscreen
        data-qa="stayfi-demo-video"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
    </div>
  </ng-container>
</sbnb-apps-detail-page>
